// Early UI wiring for e2e test reliability
document.addEventListener('DOMContentLoaded', function (): void {
  const useLocalBtn = document.getElementById('use-local');
  if (useLocalBtn) {
    useLocalBtn.addEventListener(
      'click',
      function (): void {
        const authCard = document.getElementById('auth-card');
        const appEl = document.getElementById('app');
        if (authCard) {
          authCard.hidden = true;
          authCard.remove();
        }
        if (appEl) {
          appEl.hidden = false;
        }
        const modeBanner = document.getElementById('mode-banner');
        const modeLabel = document.getElementById('mode-indicator-label');
        if (modeBanner) {
          modeBanner.hidden = false;
        }
        if (modeLabel) {
          modeLabel.textContent = 'Local mode';
        }
      },
      { once: true, capture: true }
    );
  }

  const hamburgerBtn = document.getElementById('hamburger-menu-btn');
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener(
      'click',
      function (ev: Event): void {
        ev.stopImmediatePropagation();
        ev.preventDefault();
        const expanded = hamburgerBtn.getAttribute('aria-expanded') === 'true';
        const mobileMenu = document.getElementById('mobile-menu');
        const backdrop = document.getElementById('mobile-menu-backdrop');
        const bodyEl = document.body;
        if (expanded) {
          // Close
          if (mobileMenu) mobileMenu.classList.remove('active');
          if (backdrop) backdrop.classList.remove('active');
          hamburgerBtn.setAttribute('aria-expanded', 'false');
          bodyEl.classList.remove('modal-open');
        } else {
          // Open
          if (mobileMenu) mobileMenu.classList.add('active');
          if (backdrop) backdrop.classList.add('active');
          hamburgerBtn.setAttribute('aria-expanded', 'true');
          bodyEl.classList.add('modal-open');
        }
      },
      { capture: true }
    );
  }

  // Close button handler
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener(
      'click',
      function (ev: Event): void {
        ev.stopImmediatePropagation();
        ev.preventDefault();
        const mobileMenu = document.getElementById('mobile-menu');
        const backdrop = document.getElementById('mobile-menu-backdrop');
        const bodyEl = document.body;
        if (mobileMenu) mobileMenu.classList.remove('active');
        if (backdrop) backdrop.classList.remove('active');
        if (hamburgerBtn) hamburgerBtn.setAttribute('aria-expanded', 'false');
        bodyEl.classList.remove('modal-open');
      },
      { capture: true }
    );
  }

  // Backdrop click handler (close on outside click)
  const mobileMenuBackdrop = document.getElementById('mobile-menu-backdrop');
  if (mobileMenuBackdrop) {
    mobileMenuBackdrop.addEventListener(
      'click',
      function (ev: Event): void {
        ev.stopImmediatePropagation();
        ev.preventDefault();
        const mobileMenu = document.getElementById('mobile-menu');
        const bodyEl = document.body;
        if (mobileMenu) mobileMenu.classList.remove('active');
        mobileMenuBackdrop.classList.remove('active');
        if (hamburgerBtn) hamburgerBtn.setAttribute('aria-expanded', 'false');
        bodyEl.classList.remove('modal-open');
      },
      { capture: true }
    );
  }
});

export {};
